module.exports = __webpack_public_path__ + "static/media/clients.e432473f.svg";